import Vue from 'vue'
import VueProgressBar from 'vue-progressbar';
import moment from 'moment';
import App from './App.vue'
import router from './router'
import store from './store/index'
import { googleApiKey } from './config';

import './script';
import 'popper.js';
import 'bootstrap';

import MlHeader from './components/MlHeader.vue';
import MlMenu from './components/MlMenu.vue';
import Alert from './components/elements/alert/Alert.vue';

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import './registerServiceWorker'
import VueContentLoading from 'vue-content-loading';

import * as VueGoogleMaps from 'vue2-google-maps';
import GmapMarker from 'vue2-google-maps/src/components/marker';

Vue.component('vcl', VueContentLoading);

Vue.component('ml-header', MlHeader);
Vue.component('ml-menu', MlMenu);
Vue.component('ml-alert', Alert);

Vue.component('GmapMarker', GmapMarker);

Vue.use(VueProgressBar, { color: '#c26ad6', failedColor: '#fc595e', thickness: '5px' });

Vue.config.productionTip = false
moment.locale('id');

Vue.directive('uppercase', {
	twoWay: true,
	bind: function(el) {
		addEventListener('input', () => {
			el.value = el.value.toUpperCase()
		})
	},
})

Vue.filter('toRupiah', function(value) {
	var formatter = new Intl.NumberFormat('id', {
		minimumFractionDigits: 0
	});

	return 'Rp ' + formatter.format(parseInt(value));
});

Vue.filter('toNumber', function(value) {
	var formatter = new Intl.NumberFormat('id', {
		minimumFractionDigits: 0
	});

	return formatter.format(parseInt(value));
});
Vue.filter('tanggaljam', function(value) {
	var date = moment(value).format('DD MMMM YYYY HH:mm:ss')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});

Vue.filter('tanggal', function(value) {
	var date = moment(value).format('dddd, DD MMMM YYYY')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});

Vue.filter('toTanggal', function(value) {
	var date = moment(value).format('DD MMMM YYYY')
	if (date == 'Invalid date') {
		return '-'
	} else {
		return date
	}
});
Vue.filter('jam', function(value) {
	var jam = moment(value).format('HH:mm:ss')
	if (!jam) {
		return '-'
	} else {
		return jam
	}
});

Vue.filter('toPickupType', (value) => {
	let status = [
	'DIKIRIM',
	'DIAMBIL'
	]
	return status[value];
});

Vue.filter('convertStockType', (value) => {
	if (value == 'in') {
		return 'Masuk';
	} else {
		return 'Keluar';
	}
});

Vue.filter('shipping', (value) => {
	if (value == '0') {
		return 'Pickup';
	} else {
		return 'Shipping Courier';
	}
});

Vue.filter('paymentMethod', (value) => {
	if (value == 0) {
		return 'Bonus'
	} else if (value == 1) {
		return 'Bank Transfer'
	} else {
		return 'Virtual Account'
	}
});
Vue.filter('toStatus', (value) => {
	let status = [
	'Menunggu Pembayaran',
	'Menunggu Approval',
	'Pembayaran Ditolak',
	'Pembayaran Sukses',
	'Sedang Diproses',
	'Ditolak',
	'Sudah Dikirim',
	'Sudah Diambil',
	'Pengajuan Return',
	'Selesai',
	'Return Diterima',
	'Return Ditolak',
	'Return Pengajuan Banding',
	'Sudah Dikirim Oleh Pembeli',
	'Barang Diterima & Diproses',
	'Barang Pengganti Dikirim'
	]

	return status[value];
})

Vue.filter('toStatusClass', (value) => {
	let status = [
	'background-yellow',
	'background-orange',
	'background-red',
	'btn-blue',
	'background-orange',
	'background-red',
	'background-green',
	'background-green2',
	'background-orange',
	'background-purple',
	'background-green',
	'background-red',
	'background-orange',
	'background-orange',
	'background-green',
	'background-green'
	]

	return status[value];
})

Vue.filter('toColorProduct', (value) => {
	let qty = parseInt(value)
	if (qty >= 1 && qty <= 25) {
		return 'text-yellow'
	} else if (qty > 25) {
		return 'text-green'
	} else if (qty <= 0) {
		return 'text-red'
	}
});

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')

Vue.use(VueGoogleMaps, {
	installComponents: true,
	load: {
		key: googleApiKey,
		libraries: 'places',
	}
})

import {id} from 'vuejs-datepicker/dist/locale'

Vue.mixin({
	data () {
		return {
			indonesia: id
		}
	},
	methods: {
		queryString(value) {
			let parameterObject = {}
			let parameter = '{'

			if (value.params) {
				value.params.forEach((value, index) => {
					for (const [key, val] of Object.entries(value)) {
						parameter += `"filter[${index}][${key}]":"${val}",`
					}
				})
			}
			parameter += `"limit": "${value.limit}", "page": "${value.page}", "sort": "${value.sort}", "dir": "${value.dir}"`
			parameter += '}'
			parameterObject = JSON.parse(parameter)
			return parameterObject
		},
	}
})